export default __webpack_public_path__ + "static/suraj-97d1756b97d1a87ac20a3983d4dac5b0.png";